module.exports = __webpack_public_path__ + "img/videoBgImg.9218c091.png";